import type { ResponseWithType, ResultPredictions } from './types';
import type { ResultPrediction } from '../../types/following';

const resultPredictions = ({ data }: ResponseWithType<ResultPrediction[]>): ResultPredictions => {
  return {
    __typename: 'ResultPredictions',
    resultPredictions: [...data],
  };
};

export default resultPredictions;
